module.exports = __webpack_public_path__ + "img/icon1.da59dc1b.png";